import { SVGProps } from '../types';
const VisaIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.3336 21.1443H11.5872L9.52784 13.0565C9.43009 12.6844 9.22255 12.3555 8.91725 12.2005C8.15535 11.811 7.31579 11.5009 6.3999 11.3446V11.0332H10.824C11.4346 11.0332 11.8925 11.5009 11.9689 12.0442L13.0374 17.8782L15.7824 11.0332H18.4524L14.3336 21.1443ZM19.9789 21.1443H17.3852L19.5209 11.0332H22.1146L19.9789 21.1443ZM25.4702 13.8343C25.5465 13.2897 26.0044 12.9783 26.5387 12.9783C27.3783 12.9001 28.2928 13.0565 29.0561 13.4447L29.514 11.2677C28.7508 10.9564 27.9112 10.8 27.1493 10.8C24.6319 10.8 22.8002 12.2005 22.8002 14.1443C22.8002 15.623 24.0977 16.3995 25.0136 16.8672C26.0044 17.3336 26.3861 17.645 26.3097 18.1114C26.3097 18.811 25.5465 19.1224 24.7846 19.1224C23.8687 19.1224 22.9528 18.8892 22.1146 18.4996L21.6567 20.6779C22.5725 21.0661 23.5634 21.2225 24.4793 21.2225C27.3019 21.2993 29.0561 19.9001 29.0561 17.8C29.0561 15.1553 25.4702 15.0003 25.4702 13.8343ZM38.1332 21.1443L36.0738 11.0332H33.8618C33.4038 11.0332 32.9459 11.3446 32.7932 11.811L28.9797 21.1443H31.6497L32.1826 19.6669H35.4632L35.7685 21.1443H38.1332ZM34.2434 13.7561L35.0053 17.5668H32.8696L34.2434 13.7561Z"
      fill="#172B85"
    />
  </svg>
);

export { VisaIcon };
